"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1402],{

/***/ 99859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgStar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.986 3.797a.297.297 0 00-.237-.209l-3.1-.472L5.263.171A.292.292 0 005 0a.292.292 0 00-.263.171L3.351 3.116l-3.1.472a.297.297 0 00-.237.21.317.317 0 00.074.314l2.244 2.292-.53 3.237a.314.314 0 00.117.3.284.284 0 00.308.024L5 8.437l2.773 1.528a.282.282 0 00.308-.024.314.314 0 00.117-.3l-.53-3.237 2.244-2.292a.317.317 0 00.074-.315z",
    fill: "#F0B31F"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgStar);

/***/ }),

/***/ 75006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgTrustedShopBadge(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.187 14.332c-1.1 1.626-2.63 3.108-4.687 3.108-2.175 0-3.442-1.362-3.442-3.562 0-3.561 2.63-7.052 6.335-7.052 1.242 0 2.916.502 2.916 2.009 0 2.7-4.231 3.609-6.311 4.135-.072.457-.143.908-.143 1.362 0 .933.501 1.793 1.53 1.793 1.338 0 2.412-1.29 3.203-2.247zm-1.148-5.808c0-.55-.31-.978-.884-.978-1.722 0-2.608 3.346-2.94 4.66 1.601-.48 3.824-1.794 3.824-3.682zM12 0a12 12 0 1012 11.997A11.997 11.997 0 0012 0zm-.1 19.523a7.563 7.563 0 117.564-7.563 7.563 7.563 0 01-7.563 7.56z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgTrustedShopBadge);

/***/ }),

/***/ 21890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85444);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: -1;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var BackgroundImage = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBackgroundImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            alt: ""
        }, props))
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZP.div(_templateObject());
var StyledBackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_3___default()))(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundImage);


/***/ }),

/***/ 90848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border-radius: 50%;\n    flex-shrink: 0;\n    border: ",
        ";\n    padding: 0;\n    box-sizing: border-box;\n    transition: background-color 0.1s ease-out;\n    width: ",
        ";\n    height: ",
        ";\n\n    cursor: ",
        ";\n\n    &:hover: {\n      background-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Dots = function(param) {
    var count = param.count, activeIndex = param.activeIndex, onClick = param.onClick, _size = param.size, size = _size === void 0 ? "11px" : _size, _color = param.color, color = _color === void 0 ? "#E3E4E4" : _color, border = param.border, _activeColor = param.activeColor, activeColor = _activeColor === void 0 ? "#3C4340" : _activeColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: new Array(count).fill(1).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dot, {
                as: onClick ? "button" : "div",
                type: "button",
                "aria-label": "select slide: ".concat(index + 1),
                onClick: onClick ? function() {
                    return onClick(index);
                } : undefined,
                $active: activeIndex === index,
                $size: size,
                $color: color,
                $activeColor: activeColor,
                $isButton: !!onClick,
                $border: border
            }, index);
        })
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Dot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject2(), function(param) {
    var $active = param.$active, $size = param.$size, $activeColor = param.$activeColor, $color = param.$color, $isButton = param.$isButton, _$border = param.$border, $border = _$border === void 0 ? "none" : _$border;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), $active ? $activeColor : $color, $border, $size, $size, $isButton ? "pointer" : "auto", $isButton ? $activeColor : $color);
});
/* harmony default export */ __webpack_exports__["Z"] = (Dots);


/***/ }),

/***/ 85249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65576);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85444);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Utility component with the same API as Box
 *
 * Differences:
 * - `display="flex"` is automatically applied.
 * - Accepts a `gap` property
 */ var FlexBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var _display = _param.display, display = _display === void 0 ? "flex" : _display, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "display"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxWithGaps, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        display: display,
        ref: ref
    }, props));
});
FlexBox.displayName = "FlexBox";
var BoxWithGaps = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject(), function(param) {
    var gap = param.gap;
    return gap ? gap * 8 : 0;
});
/* harmony default export */ __webpack_exports__["Z"] = (FlexBox);


/***/ }),

/***/ 42124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







function ScrollToTopButton(_param) {
    var children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        onClick: function() {
            return window.scroll({
                top: 0,
                behavior: "smooth"
            });
        },
        size: "lg",
        rounded: true
    }, restProps), {
        children: children
    }));
}
ScrollToTopButton.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_6___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node), 
    ]).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollToTopButton);


/***/ }),

/***/ 91514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(38579);
// EXTERNAL MODULE: ./node_modules/react-swipeable/es/index.js
var es = __webpack_require__(45338);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/shared/components/Dots.tsx
var Dots = __webpack_require__(90848);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/qualification/hooks/useVariationActive.ts



function useVariationActive(variation) {
    var router = (0,next_router.useRouter)();
    var isActive = (0,react.useMemo)(function() {
        return (0,ablyft/* isVariationActive */.s_)(variation);
    }, [
        variation,
        router, 
    ]);
    return isActive;
}

;// CONCATENATED MODULE: ./src/shared/components/Testimonials/TestimonialImage.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 1000px;\n  aspect-ratio: 1/1;\n  width: 62.5%;\n  position: absolute;\n  bottom: 7%;\n  right: 0.5%;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var TestimonialImage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        position: "relative",
        pr: 1,
        height: "100%",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                alt: ""
            }, props), {
                height: 452,
                width: 504,
                src: "/artifacts/images/shared/testimonial/background-foods.webp",
                layout: "responsive",
                quality: 50
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                alt: ""
            }, props), {
                src: "/artifacts/images/shared/testimonial/background-ellipse.webp",
                layout: "fill"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: props.src,
                    objectFit: "cover",
                    layout: "fill",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                alt: ""
            }, props), {
                src: "/artifacts/images/shared/testimonial/quote-icon.webp",
                layout: "fill"
            }))
        ]
    });
};
var ProfileImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
/* harmony default export */ var Testimonials_TestimonialImage = (TestimonialImage);

;// CONCATENATED MODULE: ./public/artifacts/images/shared/testimonial/bg-foods.png
/* harmony default export */ var bg_foods = ({"src":"/_next/static/media/bg-foods.4074a828.png","height":384,"width":414,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAhFBMVEWZmYCGeGVeTkdUOTK6l1+FaFekkJ84JR+CWD6wYluomYvNy7w9LCSWhmyBd2t3b2tgRjiZV1aKd3yZZ1+1mqSKfXWhl4+7u6G5ooTGh4ibj4GZh3RrSTOXhGedk2ysgUqJgWSMMy/CpZCTREFzdFyDdWPYzq6oiZvOt7W4rYDm2ceYo3Lvd/J+AAAAG3RSTlMD6Pxq+/5r+v72/XbUgdqH3ubk/LLB5Saz/OSycnjYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVR4nAXBhQJAMAAFwIelNm2hp/7//9wBRS5l1fTIrFj3+h5QzsSc49uBG+E+5yekPNweQltEOtaWXgxIguVQDD+MkQRMQl4tiAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/testimonial/bg-shape.png
/* harmony default export */ var bg_shape = ({"src":"/_next/static/media/bg-shape.debc4e5e.png","height":338,"width":365,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAJ1BMVEXo9MPw+8nq9sXo9MPn/7no9MLr98bl+MXo88Ps98ft+Mjp9sT+/9VhBGhiAAAAC3RSTlP6/uOBA2vXKLSywOqThI0AAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVHicFcrBDcAwDAOxk2InbeX95y3yJUitDX4Oa5RkXhwSYkgSZLau6KPv0TTVVtz1AykKAUgWe973AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/testimonial/quote.png
/* harmony default export */ var quote = ({"src":"/_next/static/media/quote.c996a4a4.png","height":61,"width":89,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAKlBMVEV/f019j1t9j1x7jlx9j1uBlF96jlt+kl2EmGGAkl58jVx8jVqBlF+NoWfXME6OAAAADHRSTlMCU8Y+5Y8lZuiwd3PqPqe8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVR4nAXBhwEAMAjDMDO7wv/vVgILCAMz6Accz1iexdZUjTau7CXdDwvsAM3ArxD1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/shared/components/Testimonials/TestimonialImageVariant.tsx



function TestimonialImageVariant_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: scale(",
        ");\n"
    ]);
    TestimonialImageVariant_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: image;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas: 'image';\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mask-image: url(",
        ");\n  mask-size: cover;\n  mask-position: center;\n\n  ",
        " {\n    mask-size: cover;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var TestimonialImageVariant = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        position: "relative",
        pr: 1,
        height: "100%",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageArea, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScaledBox, {
                    $scale: 0.83,
                    left: "-6%",
                    top: "-6%",
                    position: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        alt: ""
                    }, props), {
                        src: bg_foods
                    }))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageArea, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScaledBox, {
                    $scale: 0.75,
                    right: "-10%",
                    bottom: "-6%",
                    position: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        alt: ""
                    }, props), {
                        src: bg_shape
                    }))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageArea, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScaledBox, {
                    $scale: 0.63,
                    right: "-10%",
                    bottom: "-7%",
                    position: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialImageVariant_ProfileImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: props.src,
                            objectFit: "cover",
                            width: "220px",
                            height: "200px",
                            layout: "responsive",
                            alt: ""
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                right: 10,
                top: "25%",
                position: "absolute",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    alt: ""
                }, props), {
                    layout: "fixed",
                    src: quote
                }))
            })
        ]
    });
};
var ScaledBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(TestimonialImageVariant_templateObject(), function(param) {
    var $scale = param.$scale;
    return $scale;
});
var ImageArea = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject1());
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject2());
var TestimonialImageVariant_ProfileImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), bg_shape.src, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var Testimonials_TestimonialImageVariant = (TestimonialImageVariant);

// EXTERNAL MODULE: ./src/shared/helpers/createSizes.ts
var createSizes = __webpack_require__(99920);
;// CONCATENATED MODULE: ./src/shared/components/Testimonials/Testimonial.tsx

function Testimonial_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  aspect-ratio: ",
        ";\n"
    ]);
    Testimonial_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Testimonial_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 160%;\n  ",
        " {\n    font-size: 36px;\n    justify-self: start;\n    align-self: end;\n    height: fit-content;\n  }\n"
    ]);
    Testimonial_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Testimonial_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: body;\n  font-style: italic;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 168%;\n  max-width: 500px;\n\n  ",
        " {\n    max-width: none;\n  }\n"
    ]);
    Testimonial_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Testimonial_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: image;\n  aspect-ratio: 504/452;\n  width: 100%;\n  max-width: 400px;\n  ",
        " {\n    max-width: 500px;\n  }\n"
    ]);
    Testimonial_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: details;\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  text-align: center;\n\n  ",
        " {\n    gap: ",
        "px;\n    text-align: start;\n    justify-self: start;\n    align-self: start;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  width: 100%;\n  grid-template-areas:\n    'title'\n    'image'\n    'body'\n    'details';\n\n  justify-items: center;\n\n  ",
        " {\n    justify-items: center;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto auto;\n    grid-column-gap: 1rem;\n    grid-template-areas:\n      'image title'\n      'image body'\n      'image details';\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var Testimonial = function(props) {
    var isHomepageRedesignActive = useVariationActive(ablyft/* EXPERIMENT.homepageRedesign.variations.variation */.Op.homepageRedesign.variations.variation);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Testimonial_Wrapper, {
        mx: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                mb: {
                    xs: 3,
                    md: 5
                },
                textAlign: {
                    xs: "center",
                    md: "start"
                },
                children: props.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                mb: 3,
                textAlign: {
                    xs: "center",
                    md: "start"
                },
                children: [
                    '"',
                    props.body,
                    '"'
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial_ImageArea, {
                mb: {
                    xs: 4,
                    md: 0
                },
                children: isHomepageRedesignActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials_TestimonialImageVariant, {
                    src: props.imageSrc,
                    sizes: (0,createSizes/* createSizes */.H)({
                        xs: "500px"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials_TestimonialImage, {
                    src: props.imageSrc,
                    sizes: (0,createSizes/* createSizes */.H)({
                        xs: "500px"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsArea, {
                flexDirection: {
                    xs: "column",
                    md: "row"
                },
                children: [
                    props.company.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogoWrapper, {
                        aspectRatio: "".concat(props.company.image.width || 142, "/").concat(props.company.image.height || 42),
                        height: 35,
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "",
                            layout: "responsive",
                            src: props.company.image.src,
                            height: props.company.image.height || 42,
                            width: props.company.image.width || 142
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                fontWeight: "600",
                                children: props.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                children: props.company.name
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CompanyLogoWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(Testimonial_templateObject(), function(param) {
    var aspectRatio = param.aspectRatio;
    return aspectRatio;
});
var Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(Testimonial_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Body = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(Testimonial_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Testimonial_ImageArea = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(Testimonial_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var DetailsArea = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
});
var Testimonial_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var Testimonials_Testimonial = (Testimonial);

// EXTERNAL MODULE: ./src/shared/hooks/usePagination.ts + 1 modules
var usePagination = __webpack_require__(98038);
;// CONCATENATED MODULE: ./src/shared/components/Testimonials/index.tsx



function Testimonials_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  ",
        " {\n    gap: ",
        "px;\n    align-items: center;\n    display: flex;\n  }\n"
    ]);
    Testimonials_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Testimonials_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: scaleX(-1) translateX(2px);\n"
    ]);
    Testimonials_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Testimonials_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: translateX(2px);\n"
    ]);
    Testimonials_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Testimonials_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  transition: background-color 0.2s ease-out;\n  :disabled {\n    opacity: 0.6;\n  }\n  height: auto;\n\n  border-radius: 100px;\n  padding: ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n  :active {\n    background-color: ",
        ";\n  }\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    Testimonials_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var Testimonials = function(props) {
    var testimonials = (0,usePagination/* usePagination */.h)(props.items, {
        pageSize: 1
    });
    var swipeHandlers = (0,es/* useSwipeable */.QS)({
        onSwipedLeft: testimonials.next,
        onSwipedRight: testimonials.prev
    });
    var testimonial = testimonials.currentPage[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Testimonials_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                onClick: testimonials.prev,
                disabled: !testimonials.prevPage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swipeHandlers), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials_Testimonial, {
                        body: testimonial.body,
                        title: testimonial.title,
                        company: testimonial.company,
                        imageSrc: testimonial.imageSrc,
                        name: testimonial.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mt: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                            count: testimonials.pageCount,
                            onClick: testimonials.setPageIndex,
                            activeIndex: testimonials.pageIndex
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                onClick: testimonials.next,
                disabled: !testimonials.nextPage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowNext, {})
            })
        ]
    });
};
var Testimonials_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(Testimonials_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(5, 0, 4, 0);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var ArrowBack = (0,styled_components_browser_esm/* default */.ZP)(ArrowForwardIos/* default */.Z)(Testimonials_templateObject1());
var ArrowNext = (0,styled_components_browser_esm/* default */.ZP)(ArrowForwardIos/* default */.Z)(Testimonials_templateObject2());
var PaginationButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonBase/* default */.Z)(Testimonials_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(1, 1);
}, function(param) {
    var theme = param.theme;
    return theme.palette.grey[200];
}, function(param) {
    var theme = param.theme;
    return theme.palette.grey[300];
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var components_Testimonials = (Testimonials);


/***/ }),

/***/ 99920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ createSizes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var system_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35273);


/**
 * Utility function that helps defining the `sizes` property, of the `next/image` component
 * Based on the theme's breakpoints
 */ var createSizes = function(options) {
    var optionsAsEntries = Object.entries(options);
    // Sorting, so it goes from the smallest breakpoint to the biggest. (mobile-first approach)
    var sortedOptionEntries = optionsAsEntries.sort(function(param, param1) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), breakpointKeyA = _param[0], _param1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param1, 1), breakpointKeyB = _param1[0];
        var breakpointA = system_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].breakpoints.values */ .Z.breakpoints.values[breakpointKeyA];
        var breakpointB = system_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].breakpoints.values */ .Z.breakpoints.values[breakpointKeyB];
        if (breakpointA > breakpointB) {
            return -1;
        }
        if (breakpointA === breakpointB) {
            return 0;
        }
        return 1;
    });
    var sizesArray = sortedOptionEntries.map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), breakpointKey = _param[0], size = _param[1];
        return "(min-width: ".concat(system_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].breakpoints.values */ .Z.breakpoints.values[breakpointKey], "px) ").concat(size);
    });
    return sizesArray.join(", ");
};


/***/ }),

/***/ 77976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCities; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26793);


var COUNTRY_MAPPER = {
    "da-dk": "common:citiesDenmark",
    "en-uk": "common:citiesUK",
    "de-at": "common:citiesAustria",
    "de-ch": "common:citiesSwitzerland",
    "de-de": "common:cities",
    "en-de": "common:cities",
    en: "common:cities",
    de: "common:cities",
    da: "common:citiesDenmark"
};
function useCities() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$)().t;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    var countryCities = locale ? COUNTRY_MAPPER[locale] : [];
    var cities = t("".concat(countryCities), {
        returnObjects: true
    });
    var cityNames = Object.values(cities).sort();
    var cityKeys = Object.keys(cities);
    return {
        cities: cities,
        cityKeys: cityKeys,
        cityNames: cityNames
    };
}


/***/ }),

/***/ 9988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ useLocalizeCity; },
/* harmony export */   "Qu": function() { return /* binding */ useLocalizedCity; },
/* harmony export */   "yC": function() { return /* binding */ getLocalizedCity; }
/* harmony export */ });
/* unused harmony export getLocalizedCities */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26793);



var getLocalizedCities = function(t) {
    var citiesGermany = t("common:cities", {
        returnObjects: true
    });
    var citiesAustria = t("common:citiesAustria", {
        returnObjects: true
    });
    var citiesSwitzerland = t("common:citiesSwitzerland", {
        returnObjects: true
    });
    var citiesDenmark = t("common:citiesDenmark", {
        returnObjects: true
    });
    var citiesUK = t("common:citiesUK", {
        returnObjects: true
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, citiesGermany, citiesAustria, citiesSwitzerland, citiesDenmark, citiesUK);
};
var getLocalizedCity = function(city, t) {
    return getLocalizedCities(t)[city];
};
/**
 * Returns a translate function, that translates a city key,
 * regardless of which country namespace it is under
 */ var useLocalizeCity = function() {
    var cities = useAllCity();
    var translateCity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(city) {
        return cities[city];
    }, [
        cities
    ]);
    return translateCity;
};
var useLocalizedCity = function(city) {
    var translateCity = useLocalizeCity();
    return translateCity(city);
};
var useAllCity = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)("common").t;
    var allCities = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return getLocalizedCities(t);
    }, [
        t
    ]);
    return allCities;
};


/***/ }),

/***/ 98038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ usePagination; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/helpers/array.ts
function chunk(array, length) {
    var chunks = [];
    var i = 0;
    var n = array.length;
    while(i < n){
        chunks.push(array.slice(i, i += length));
    }
    return chunks;
}

;// CONCATENATED MODULE: ./src/shared/hooks/usePagination.ts


var usePagination = function(items, param) {
    var pageSize = param.pageSize, initialPage = param.initialPage, limit = param.limit;
    var ref = (0,react.useState)(initialPage || 0), pageIndex = ref[0], setPageIndex = ref[1];
    var paginatedItems = (0,react.useMemo)(function() {
        return chunk(limit ? items.slice(0, limit) : items, pageSize);
    }, [
        items,
        limit,
        pageSize
    ]);
    var lastPageIndex = paginatedItems.length - 1;
    var next = (0,react.useCallback)(function() {
        return setPageIndex(function(prev) {
            return (prev + 1) % paginatedItems.length;
        });
    }, [
        pageSize
    ]);
    var prev = (0,react.useCallback)(function() {
        return setPageIndex(function(prev) {
            return prev - 1 === -1 ? lastPageIndex : prev - 1;
        });
    }, [
        pageSize
    ]);
    return {
        pages: paginatedItems,
        currentPage: paginatedItems[pageIndex],
        nextPage: paginatedItems[pageIndex + 1],
        prevPage: paginatedItems[pageIndex - 1],
        pageCount: paginatedItems.length,
        pageIndex: pageIndex,
        next: next,
        prev: prev,
        setPageIndex: setPageIndex
    };
};


/***/ }),

/***/ 58308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CTAWithBenefits; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/shared/helpers/createSizes.ts
var createSizes = __webpack_require__(99920);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/shared/components/BenefitIcons.js




function createImageIconComponent(src) {
    var BenefitIcon = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
            alt: "",
            height: 50,
            width: 50,
            src: src
        }, props));
    };
    return BenefitIcon;
}
var BenefitIcons = {
    ShefIcon: createImageIconComponent("/artifacts/images/hc-shef-icon.webp"),
    NotebookIcon: createImageIconComponent("/artifacts/images/hc-notebook-icon.webp"),
    CustomerIcon: createImageIconComponent("/artifacts/images/hc-customer-icon.webp"),
    CheckmarkIcon: createImageIconComponent("/artifacts/images/hc-checkmark-icon.webp"),
    FiveStarIcon: createImageIconComponent("/artifacts/images/hc-5-star-icon.webp")
};
/* harmony default export */ var components_BenefitIcons = (BenefitIcons);

// EXTERNAL MODULE: ./src/shared/components/FlexBox.tsx
var FlexBox = __webpack_require__(85249);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/components/BenefitsRow.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: ",
        "px;\n  justify-items: start;\n  align-items: center;\n  padding: ",
        ";\n\n  ",
        " {\n    grid-template-columns: repeat(2, auto);\n  }\n\n  ",
        " {\n    display: flex;\n    justify-content: space-between;\n    gap: ",
        "px;\n    align-items: center;\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fafaf8;\n  padding: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function BenefitsRow(param) {
    var _containerSize = param.containerSize, containerSize = _containerSize === void 0 ? "md" : _containerSize;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            size: containerSize,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsLayout, {
                children: getBenefits(t).map(function(param) {
                    var Icon = param.Icon, text = param.text;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* default */.Z, {
                        alignItems: "center",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                flexShrink: "0",
                                children: Icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                children: text
                            })
                        ]
                    }, text);
                })
            })
        })
    });
}
var BenefitsLayout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2, 0);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(8);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2, 0);
});
var BenefitsWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
});
function getBenefits(t) {
    return [
        {
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BenefitIcons.NotebookIcon, {
                width: "35px",
                height: "35px"
            }),
            text: t("common:benefits.nr1")
        },
        {
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BenefitIcons.CustomerIcon, {
                width: "35px",
                height: "35px"
            }),
            text: t("common:benefits.customerCount", {
                count: "13.500"
            })
        },
        {
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BenefitIcons.ShefIcon, {
                width: "35px",
                height: "35px"
            }),
            text: t("common:benefits.catererCount", {
                count: constants/* BENEFITS.CATERER_COUNT */.pV.CATERER_COUNT
            })
        },
        {
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BenefitIcons.FiveStarIcon, {
                width: "40px",
                height: "30px"
            }),
            text: t("common:benefits.satisfaction", {
                percent: constants/* BENEFITS.CUSTOMER_SATISFACTION_PERCENT */.pV.CUSTOMER_SATISFACTION_PERCENT
            })
        }, 
    ];
}

// EXTERNAL MODULE: ./src/static_pages/components/CitySelector.tsx
var CitySelector = __webpack_require__(1183);
;// CONCATENATED MODULE: ./src/static_pages/components/CTAWithBenefits/index.tsx

function CTAWithBenefits_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  max-width: 600px;\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    CTAWithBenefits_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CTAWithBenefits_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 400px;\n  width: 100%;\n  padding-top: ",
        "px;\n\n  ",
        " {\n    padding: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n    min-width: 425px;\n  }\n"
    ]);
    CTAWithBenefits_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column-reverse;\n  gap: ",
        "px;\n\n  ",
        " {\n    flex-direction: row;\n    gap: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n\n  background: ",
        ";\n\n  ",
        " {\n    padding-top: ",
        "px;\n    padding-bottom: ",
        "px;\n    padding-right: ",
        "px;\n    padding-left: ",
        "px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-line;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 160%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var DEFAULT_IMAGE_SRC = "/artifacts/images/marketing_pages/food-group-cta-illustration.webp";
function CTAWithBenefits(param) {
    var virtualEvent = param.virtualEvent, cityFromSlug = param.cityFromSlug, imageSrc = param.imageSrc, _containerSize = param.containerSize, containerSize = _containerSize === void 0 ? "md" : _containerSize;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var isTablet = (0,useBreakpoints/* useBreakpointUp */._)("md");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColorBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    size: containerSize,
                    disableGutters: !isTablet,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                                children: [
                                    virtualEvent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Typography */.ZT, {
                                            variant: "h3",
                                            mb: 4,
                                            align: "center",
                                            children: [
                                                t("virtualEventsHero.title.a"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                    variant: "inherit",
                                                    slab: true,
                                                    color: "secondary",
                                                    children: t("virtualEventsHero.title.b")
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        variant: "h3",
                                        mb: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                            t: t,
                                            i18nKey: "footerCTA.title",
                                            components: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}, "span")
                                            ]
                                        })
                                    }),
                                    virtualEvent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        display: "flex",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                                            size: "lg",
                                            component: "a",
                                            href: (0,urls/* marketplaceURL */.j5)("/catering/virtual_events"),
                                            children: t("common:labels.findVirtualEvents")
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        display: "flex",
                                        mt: 4,
                                        maxWidth: 500,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitySelector/* default */.Z, {
                                            cityKeyContentful: cityFromSlug
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    height: 278,
                                    width: 425,
                                    layout: "responsive",
                                    src: imageSrc || DEFAULT_IMAGE_SRC,
                                    sizes: (0,createSizes/* createSizes */.H)({
                                        xs: "100vw",
                                        sm: "400px"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsRow, {})
        ]
    });
}
var ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(CTAWithBenefits_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2.5, 8, 2.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(5, 3, 5, 0);
});
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(CTAWithBenefits_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 0, 2, 0);
});
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var BackgroundColorBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject3(), function(props) {
    return props.theme.colors.heroGradient;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject4());


/***/ }),

/***/ 1183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77269);
/* harmony import */ var _material_ui_icons_LocationOn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59832);
/* harmony import */ var _material_ui_lab_Autocomplete__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11514);
/* harmony import */ var _material_ui_lab_Autocomplete__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26270);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85444);
/* harmony import */ var shared_helpers_cities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6619);
/* harmony import */ var shared_hooks_useCities__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77976);
/* harmony import */ var shared_hooks_useLocalizeCity__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9988);
/* harmony import */ var static_pages_marketing_pages_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10904);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 10px;\n\n  ",
        " {\n    position: absolute;\n    padding: 0;\n    width: auto;\n    right: 0px;\n    top: 50%;\n    height: 100%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  width: 100%;\n  overflow: hidden;\n\n  ",
        " {\n    max-width: ",
        ";\n    width: 100%;\n    display: flex;\n    box-shadow: 0 4px 40px rgba(62, 41, 29, 0.1);\n    border-radius: 500px;\n    position: relative;\n    transition: ",
        ";\n    z-index: 1;\n    &:hover {\n      box-shadow: 0 4px 50px rgba(62, 41, 29, 0.15);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  position: relative;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: 14px;\n  top: 14px;\n  z-index: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  min-height: 52px; // Same as the input field\n  padding: 11px 24px;\n\n  border-radius: 100px;\n\n  ",
        " {\n    border-radius: 0;\n    min-height: 0px;\n    height: 100%;\n  }\n\n  svg {\n    font-size: 1rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: white;\n  padding: 12px ",
        "px 12px\n    ",
        "px;\n  border-radius: 500px;\n  box-shadow: 0px 4px 40px rgba(62, 41, 29, 0.08);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













function CitySelector(param) {
    var cityKeyContentful = param.cityKeyContentful, cateringCategories = param.cateringCategories, _buttonLabelKey = param.buttonLabelKey, buttonLabelKey = _buttonLabelKey === void 0 ? "common:labels.findCaterers" : _buttonLabelKey;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)("static_pages").t;
    var ref = (0,shared_hooks_useCities__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), cities = ref.cities, cityNames = ref.cityNames, cityKeys = ref.cityKeys;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), autocompleteValue = ref1[0], setAutocompleteValue = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), inputValue = ref2[0], setInputValue = ref2[1];
    var localizeCity = (0,shared_hooks_useLocalizeCity__WEBPACK_IMPORTED_MODULE_7__/* .useLocalizeCity */ .Dt)();
    var handleRedirect = function(city) {
        if (city === "berlin") {
            window.location.href = (0,static_pages_marketing_pages_helpers__WEBPACK_IMPORTED_MODULE_8__/* .buildFunnelUrl */ .$e)({
                city: city,
                cateringCategories: cateringCategories,
                router: router
            });
            return;
        }
        (0,shared_helpers_cities__WEBPACK_IMPORTED_MODULE_5__/* .persistCityInLocalStorage */ .el)(city);
        router.push((0,static_pages_marketing_pages_helpers__WEBPACK_IMPORTED_MODULE_8__/* .buildFunnelUrl */ .$e)({
            city: city,
            cateringCategories: cateringCategories,
            router: router
        }));
    };
    var handleAutocompleteSelection = function(event, city) {
        var cityKey = cityKeys.find(function(cityKey) {
            return cities[cityKey] === city;
        });
        if (cityKey) {
            handleRedirect(cityKey);
        }
    };
    var handleFindCaterersSelection = function() {
        handleRedirect(autocompleteValue === null || autocompleteValue === void 0 ? void 0 : autocompleteValue.toLowerCase());
    };
    var filterOptions = (0,_material_ui_lab_Autocomplete__WEBPACK_IMPORTED_MODULE_10__/* .createFilterOptions */ .D)({
        matchFrom: "start",
        stringify: function(option) {
            return option;
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (cityKeyContentful) {
            var localizedCity = localizeCity(cityKeyContentful);
            if (localizedCity) {
                setAutocompleteValue(cityKeyContentful);
                setInputValue(localizedCity);
            }
        }
    }, [
        cityKeyContentful,
        localizeCity
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CitySelectorWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TextFieldWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LocationIconWrapper, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_LocationOn__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            color: "secondary"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab_Autocomplete__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                        freeSolo: true,
                        autoComplete: true,
                        autoHighlight: true,
                        value: autocompleteValue,
                        onChange: handleAutocompleteSelection,
                        options: cityNames,
                        inputValue: inputValue,
                        filterOptions: filterOptions,
                        renderOption: function(option) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                variant: "body1",
                                fontWeight: 500,
                                id: "city-selector-".concat(option),
                                children: option
                            });
                        },
                        renderInput: function(params) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTextField, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, params), {
                                placeholder: t("common:labels.selectCity"),
                                onChange: function(event) {
                                    return setInputValue(event.target.value);
                                },
                                InputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, params.InputProps), {
                                    disableUnderline: true
                                })
                            }));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextFieldButtonWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextFieldButton, {
                    size: "lg",
                    onClick: handleFindCaterersSelection,
                    "aria-label": t(buttonLabelKey),
                    children: t(buttonLabelKey)
                })
            })
        ]
    });
}
var TextFieldButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var CitySelectorWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(props) {
    return props.width;
}, function(props) {
    return props.theme.transitions.create("box-shadow", {
        duration: ".2s"
    });
});
var TextFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject2());
var LocationIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject3());
var TextFieldButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledTextField = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_templateObject5(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(6);
});
/* harmony default export */ __webpack_exports__["Z"] = (CitySelector);


/***/ }),

/***/ 1105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85444);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function TrustedCustomers(param) {
    var _items = param.items, items = _items === void 0 ? "all" : _items;
    var customers = {
        barmer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            mx: {
                xs: 4,
                lg: 5
            },
            my: 2,
            width: {
                xs: 74,
                md: 127
            },
            height: {
                xs: 14,
                md: 20
            },
            position: "relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                alt: "The logo of Barmer",
                src: "/artifacts/images/homepage/trust-customer-icons/barmer.webp",
                layout: "responsive",
                width: "127",
                height: "20"
            })
        }),
        dell: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            mx: {
                xs: 4,
                lg: 5
            },
            my: 2,
            width: {
                xs: 35,
                md: 46
            },
            height: {
                xs: 35,
                md: 46
            },
            position: "relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                alt: "The logo of Dell",
                src: "/artifacts/images/homepage/trust-customer-icons/dell.webp",
                layout: "responsive",
                width: "46",
                height: "46"
            })
        }),
        infarm: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            mx: {
                xs: 4,
                lg: 5
            },
            my: 2,
            width: {
                xs: 67,
                md: 103
            },
            height: {
                xs: 12,
                md: 25
            },
            position: "relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                alt: "The logo of Infarm",
                src: "/artifacts/images/homepage/trust-customer-icons/infarm.webp",
                layout: "responsive",
                width: "103",
                height: "25"
            })
        }),
        ebay: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            mx: {
                xs: 4,
                lg: 5
            },
            my: 2,
            width: 62,
            height: {
                xs: 13,
                md: 25
            },
            position: "relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                alt: "The logo of Ebay",
                src: "/artifacts/images/homepage/trust-customer-icons/ebay.webp",
                layout: "responsive",
                width: "62",
                height: "25"
            })
        }),
        "hello-fresh": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            mx: {
                xs: 4,
                lg: 5
            },
            my: 2,
            width: {
                xs: 44,
                md: 66
            },
            height: {
                xs: 22,
                md: 32
            },
            position: "relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                alt: "The logo of Hellofresh",
                src: "/artifacts/images/homepage/trust-customer-icons/hellofresh.webp",
                layout: "responsive",
                width: "66",
                height: "32"
            })
        }),
        audi: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            mx: {
                xs: 4,
                lg: 5
            },
            my: 2,
            width: {
                xs: 47,
                md: 56
            },
            height: {
                xs: 9,
                md: 20
            },
            position: "relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                alt: "The logo of Audi",
                src: "/artifacts/images/homepage/trust-customer-icons/audi.webp",
                layout: "responsive",
                width: "56",
                height: "20"
            })
        })
    };
    var customersToRender = items === "all" ? Object.entries(customers) : Object.entries(customers).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(param, 1), key = _param[0];
        return items.includes(key);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: {
                xs: "wrap",
                md: "nowrap"
            },
            width: "100%",
            maxWidth: {
                xs: "80vw",
                md: "none"
            },
            mx: "auto",
            children: customersToRender.map(function(customer) {
                return customer[1];
            })
        })
    });
}
var CustomerLogo = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_4___default()))(_templateObject(), function(props) {
    return props.theme.spacing(0, 10);
});
/* harmony default export */ __webpack_exports__["Z"] = (TrustedCustomers);


/***/ }),

/***/ 41402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ marketing_pages_SEAPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hub/helpers/contentful.tsx
var contentful = __webpack_require__(55352);
// EXTERNAL MODULE: ./src/shared/components/Testimonials/index.tsx + 7 modules
var Testimonials = __webpack_require__(91514);
// EXTERNAL MODULE: ./src/shared/layouts/MainLayout.tsx + 1 modules
var MainLayout = __webpack_require__(89452);
// EXTERNAL MODULE: ./src/shared/services/trustedShops/handleRatings.ts
var handleRatings = __webpack_require__(95046);
// EXTERNAL MODULE: ./src/static_pages/components/CTAWithBenefits/index.tsx + 2 modules
var CTAWithBenefits = __webpack_require__(58308);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/CertificateSection.tsx + 1 modules
var CertificateSection = __webpack_require__(41534);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/HowItWorksCTA.tsx
var HowItWorksCTA = __webpack_require__(4775);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/shared/components/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(21890);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/createSizes.ts
var createSizes = __webpack_require__(99920);
// EXTERNAL MODULE: ./src/static_pages/components/CitySelector.tsx
var CitySelector = __webpack_require__(1183);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 4 modules
var Box = __webpack_require__(65576);
// EXTERNAL MODULE: ./public/artifacts/icons/star.svg
var star = __webpack_require__(99859);
// EXTERNAL MODULE: ./public/artifacts/icons/trusted-shop-badge.svg
var trusted_shop_badge = __webpack_require__(75006);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/SEAPage/HeroRatings.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: white;\n  width: max-content;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  align-self: flex-start;\n  margin-top: 11px;\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  color: white;\n  font-size: 24px;\n\n  margin-right: 6px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  color: white;\n  font-size: 12px;\n  line-height: 172.5%;\n  align-self: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        "px;\n  background-color: inherit;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var HeroRatings = function(param) {
    var rating = param.rating, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 33 : _iconSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(trusted_shop_badge/* default */.Z, {
                    fill: "white",
                    height: iconSize,
                    width: iconSize
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                        children: Array(Math.ceil(rating)).fill(1).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(star/* default */.Z, {
                                viewBox: "0 0 10 10",
                                height: "12px",
                                width: "12px"
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingNumber, {
                                children: [
                                    rating.toFixed(1),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFrom, {
                                children: "/ 5.0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var RatingText = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var Stars = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), function(param) {
    var spacing = param.theme.spacing;
    return spacing(0.5);
});
var ContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject2());
var RatingNumber = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var RatingFrom = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject5());
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
/* harmony default export */ var SEAPage_HeroRatings = (HeroRatings);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/SEAPage/Hero.tsx

function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: ",
        ";\n\n  ",
        " {\n    align-items: center;\n    background-size: cover;\n    display: flex;\n    justify-content: center;\n    padding: ",
        ";\n  }\n"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: white;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  display: flex;\n  padding: ",
        ";\n  width: 100%;\n  border-radius: ",
        "px;\n  max-width: ",
        "px;\n  margin: 0 auto;\n\n  ",
        " {\n    align-items: stretch;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: ",
        "px;\n    padding: ",
        ";\n    max-width: 1060px;\n    text-align: left;\n  }\n"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 520px;\n  text-align: center;\n  margin-bottom: 0px;\n\n  ",
        " {\n  }\n  ",
        " {\n    margin-bottom: ",
        "px;\n    flex: 5;\n    text-align: start;\n    display: flex;\n    margin-bottom: ",
        "px;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    flex: 3;\n    max-width: 400px;\n  }\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Hero_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 26px;\n  line-height: 160%;\n  margin: 0;\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    font-size: 42px;\n    margin-bottom: 0;\n    line-height: 160%;\n  }\n"
    ]);
    Hero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Hero_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        "px;\n  margin: ",
        ";\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n  }\n\n  ",
        " {\n    justify-content: start;\n    margin: ",
        ";\n  }\n"
    ]);
    Hero_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Hero_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    Hero_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/artifacts/images/homepage/hero-alternate/checkmark.svg')\n    no-repeat left 30%;\n  font-size: 14px;\n  font-weight: ",
        ";\n  padding: ",
        ";\n\n  ",
        " {\n    font-size: 17px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}











function Hero(param) {
    var title = param.title, city = param.city, keywords = param.keywords, rating = param.rating;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroSection, {
            as: "section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
                    priority: true,
                    layout: "fill",
                    alt: "",
                    objectFit: "cover",
                    objectPosition: "50% 70%",
                    quality: 90,
                    src: "/artifacts/images/homepage/hero-alternate/bg.jpg",
                    sizes: (0,createSizes/* createSizes */.H)({
                        xs: "100vw"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnLeft, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroTitle, {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                    pr: {
                                        xs: 0,
                                        md: 4
                                    },
                                    pb: {
                                        xs: 4,
                                        md: 0.5
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitySelector/* default */.Z, {
                                        cityKeyContentful: city,
                                        cateringCategories: keywords,
                                        buttonLabelKey: "marketingPages.hero.generalCTA"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnRight, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SEAPage_HeroRatings, {
                                            rating: rating
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            alt: "ClimatePartner Logo",
                                            src: "/artifacts/images/homepage/hero-alternate/climatepartner_2x.png",
                                            objectFit: "contain",
                                            width: 190,
                                            height: 29
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checklist, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistItem, {
                                            children: t("common:benefits.quickAndFree")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistItem, {
                                            children: t("common:benefits.satisfaction", {
                                                percent: constants/* BENEFITS.CUSTOMER_SATISFACTION_PERCENT */.pV.CUSTOMER_SATISFACTION_PERCENT
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistItem, {
                                            children: t("common:benefits.personalService")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistItem, {
                                            children: t("common:benefits.catererCount", {
                                                count: constants/* BENEFITS.CATERER_COUNT */.pV.CATERER_COUNT
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var HeroSection = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject(), function(props) {
    return props.theme.spacing(13, 2);
}, function(props) {
    return props.theme.breakpoints.up("md");
}, function(props) {
    return props.theme.spacing(20, 4);
});
var Content = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject1(), function(props) {
    return props.theme.palette.secondary["450"];
}, function(props) {
    return props.theme.spacing(4.2, 3);
}, function(props) {
    return props.theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.width("sm");
}, function(props) {
    return props.theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(8);
}, function(props) {
    return props.theme.spacing(4.5, 6);
});
var ColumnLeft = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject2(), function(props) {
    return props.theme.breakpoints.up("sm");
}, function(props) {
    return props.theme.breakpoints.up("md");
}, function(props) {
    return props.theme.spacing(5);
}, function(props) {
    return props.theme.spacing(0);
});
var ColumnRight = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject3(), function(props) {
    return props.theme.breakpoints.up("md");
});
var HeroTitle = styled_components_browser_esm/* default.h1 */.ZP.h1(Hero_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(4.5);
}, function(props) {
    return props.theme.breakpoints.up("md");
});
var LogoWrapper = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject5(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0, 0, 4);
}, function(props) {
    return props.theme.breakpoints.up("sm");
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.up("md");
}, function(props) {
    return props.theme.spacing(0, 0, 3);
});
var Checklist = styled_components_browser_esm/* default.ul */.ZP.ul(Hero_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var ChecklistItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject7(), function(props) {
    return props.theme.typography.fontWeightBold;
}, function(props) {
    return props.theme.spacing(0, 0, 0, 4);
}, function(props) {
    return props.theme.breakpoints.up("md");
});
/* harmony default export */ var SEAPage_Hero = (Hero);

// EXTERNAL MODULE: ./src/static_pages/marketing_pages/SEAPage/TrustedCustomers.tsx
var TrustedCustomers = __webpack_require__(1105);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/SEAPage/index.tsx














function SEAPage(param) {
    var meta = param.meta, ratings = param.ratings, hero = param.hero, testimonials = param.testimonials;
    var renderHero = function() {
        if (!hero) {
            return null;
        }
        if (typeof hero === "object" && "title" in hero) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SEAPage_Hero, {
                title: hero.title,
                rating: (0,handleRatings/* getRating */.h1)(ratings),
                city: hero.city
            });
        }
        return hero;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
        ratings: ratings,
        hideNavigationLinks: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: meta.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: meta.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: meta.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: meta.description
                    })
                ]
            }),
            renderHero(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mt: {
                    xs: 6,
                    md: 9
                },
                mb: {
                    xs: 4,
                    md: 9
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CertificateSection/* default */.Z, {
                    containerSize: 1152
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "md",
                pb: {
                    xs: 4,
                    md: 9
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksCTA/* default */.Z, {})
            }),
            (testimonials === null || testimonials === void 0 ? void 0 : testimonials.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        mb: {
                            xs: 0,
                            md: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials["default"], {
                            items: testimonials.map(function(testimonial) {
                                var ref, ref1;
                                return {
                                    imageSrc: (0,contentful/* getContentfulImageUrl */.l)(testimonial.fields.image),
                                    body: testimonial.fields.body,
                                    company: {
                                        name: testimonial.fields.company,
                                        image: testimonial.fields.companyLogo ? {
                                            src: (0,contentful/* getContentfulImageUrl */.l)(testimonial.fields.companyLogo),
                                            height: (ref = testimonial.fields.companyLogo.fields.file.details.image) === null || ref === void 0 ? void 0 : ref.height,
                                            width: (ref1 = testimonial.fields.companyLogo.fields.file.details.image) === null || ref1 === void 0 ? void 0 : ref1.width
                                        } : undefined
                                    },
                                    title: testimonial.fields.title,
                                    name: testimonial.fields.name
                                };
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        mb: {
                            xs: 4,
                            md: 9
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedCustomers/* default */.Z, {})
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAWithBenefits/* default */.Z, {
                containerSize: "sm"
            })
        ]
    });
}
/* harmony default export */ var marketing_pages_SEAPage = (SEAPage);


/***/ }),

/***/ 41534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CertificateSection; }
});

// UNUSED EXPORTS: CertificateSection

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 4 modules
var Box = __webpack_require__(65576);
;// CONCATENATED MODULE: ./src/shared/components/TwoColumnsWithImage.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n\n  ",
        " {\n    align-self: end;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: description;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: image;\n  justify-self: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  justify-items: center;\n\n  place-content: center;\n  grid-row-gap: ",
        "px;\n  grid-template-columns: 1fr;\n  grid-template-areas:\n    'title'\n    'image'\n    'description';\n\n  ",
        " {\n    justify-items: ",
        ";\n\n    padding-top: ",
        "px;\n\n    grid-template-columns: ",
        ";\n\n    grid-template-areas: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var TwoColumnsWithImage = function(_param) {
    var _imagePosition = _param.imagePosition, imagePosition = _imagePosition === void 0 ? "right" : _imagePosition, children = _param.children, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "imagePosition",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutGrid, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        imagePosition: imagePosition
    }, boxProps), {
        children: children
    }));
};
var TitleWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var DescriptionWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject1());
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject2());
TwoColumnsWithImage.Image = ImageWrapper;
TwoColumnsWithImage.Title = TitleWrapper;
TwoColumnsWithImage.Description = DescriptionWrapper;
var LayoutGrid = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var imagePosition = param.imagePosition;
    return imagePosition === "left" ? "end" : "start";
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0);
}, function(param) {
    var imagePosition = param.imagePosition;
    return imagePosition === "left" ? "1fr minmax(200px, 500px)" : "minmax(200px, 500px) 1fr";
}, function(param) {
    var imagePosition = param.imagePosition;
    return imagePosition === "left" ? "\n        'image title'\n        'image description'\n    " : "\n        'title image'\n        'description image'\n    ";
});
/* harmony default export */ var components_TwoColumnsWithImage = (TwoColumnsWithImage);

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/CertificateSection.tsx

function CertificateSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 140%;\n  text-align: center;\n\n  ",
        " {\n    text-align: start;\n    font-size: 36px;\n  }\n"
    ]);
    CertificateSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CertificateSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 168%;\n  text-align: center;\n  ",
        " {\n    text-align: start;\n  }\n"
    ]);
    CertificateSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var CertificateSection = function(param) {
    var _containerSize = param.containerSize, containerSize = _containerSize === void 0 ? "md" : _containerSize;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        size: containerSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_TwoColumnsWithImage, {
            component: "section",
            imagePosition: "right",
            px: {
                xs: 2,
                md: 4,
                lg: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TwoColumnsWithImage.Title, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: t("marketingPages.certifiedSection.title")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TwoColumnsWithImage.Image, {
                    justifySelf: {
                        xs: "center",
                        md: "end!important"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        height: 337,
                        width: 473,
                        objectFit: "contain",
                        src: "/artifacts/images/marketing_pages/certified.webp"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TwoColumnsWithImage.Description, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: t("marketingPages.certifiedSection.description")
                    })
                })
            ]
        })
    });
};
var Title = styled_components_browser_esm/* default.h3 */.ZP.h3(CertificateSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Description = styled_components_browser_esm/* default.p */.ZP.p(CertificateSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var components_CertificateSection = (CertificateSection);


/***/ }),

/***/ 4775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85444);
/* harmony import */ var shared_components_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42124);
/* harmony import */ var shared_helpers_createSizes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99920);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 300px;\n  ",
        " {\n    max-width: none;\n    position: relative;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  position: relative;\n  gap: ",
        "px;\n  flex-direction: column;\n  text-align: center;\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n  }\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: ",
        "px;\n\n  ",
        " {\n    flex-basis: 0;\n    flex-grow: 1;\n    flex-shrink: 0;\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








function HowItWorksCTA() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("static_pages").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                maxWidth: "600px",
                mt: {
                    xs: 4,
                    md: 6
                },
                textAlign: "center",
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                    textAlign: "center",
                    variant: "h3",
                    component: "p",
                    mb: 4,
                    fontSize: {
                        xs: 24,
                        md: 36
                    },
                    xs: {
                        lineHeight: 1.8
                    },
                    children: t("marketingPages.howItWorksCTA.title")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HowItWorksContent, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Item, {
                        imageSrc: "/artifacts/images/marketing_pages/sea/how_it_works/step1.webp",
                        title: t("marketingPages.howItWorksCTA.section1.title"),
                        description: t("marketingPages.howItWorksCTA.section1.content")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Item, {
                        imageSrc: "/artifacts/images/marketing_pages/sea/how_it_works/step2.webp",
                        title: t("marketingPages.howItWorksCTA.section2.title"),
                        description: t("marketingPages.howItWorksCTA.section2.content")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Item, {
                        imageSrc: "/artifacts/images/marketing_pages/sea/how_it_works/step3.webp",
                        title: t("marketingPages.howItWorksCTA.section3.title"),
                        description: t("marketingPages.howItWorksCTA.section3.content")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mb: 1.5,
                pt: 4,
                textAlign: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(shared_components_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: t("common:labels.findCaterers")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                    fontSize: 14,
                    textAlign: "center",
                    children: t("common:labels.requestCaterersCTA")
                })
            })
        ]
    });
}
var Item = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HowItWorksItem, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
                px: {
                    xs: 0,
                    sm: 2,
                    lg: 4
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    width: 280,
                    height: 230,
                    objectFit: "cover",
                    layout: "responsive",
                    src: props.imageSrc,
                    sizes: (0,shared_helpers_createSizes__WEBPACK_IMPORTED_MODULE_6__/* .createSizes */ .H)({
                        xs: "300px",
                        sm: "30vw"
                    }),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                px: 2,
                flex: 1,
                textAlign: {
                    sm: "center"
                },
                pt: {
                    sm: 4
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                        variant: "h4",
                        lineHeight: "160%",
                        fontSize: {
                            xs: 18,
                            md: 20
                        },
                        pb: 1,
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                        variant: "body2",
                        lineHeight: "168%",
                        children: props.description
                    })
                ]
            })
        ]
    });
};
var ImageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject(), function(props) {
    return props.theme.breakpoints.up("sm");
});
var HowItWorksContent = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(props) {
    return props.theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0);
}, function(props) {
    return props.theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
});
var HowItWorksItem = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0);
});
/* harmony default export */ __webpack_exports__["Z"] = (HowItWorksCTA);


/***/ })

}]);